import { getNgbDateStructFromDayJs } from '@mwe/utils';
import dayjs from 'dayjs';

export const MIN_BIRTHYEAR = 1900;

export const minBirthDate = getNgbDateStructFromDayJs(dayjs().subtract(dayjs().year() - 1900, 'year'));
export const maxBirthDate = getNgbDateStructFromDayJs(dayjs().subtract(18, 'year'));

export const minUmmeldedatum = getNgbDateStructFromDayJs(dayjs());
export const maxUmmeldedatum = getNgbDateStructFromDayJs(dayjs().add(30, 'day'));
